import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { AnalyticsBaseReportResponse } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper } from '../utils';
import { AnalyticsBaseReportSectionHandler } from './details.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { ContextualizedHealthIssue, HealthIssueService } from '../healthissues/healthissue.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AnalyticsDashboardListSectionHandler } from './dashboards.section';
import { uniqBy } from 'lodash';
import { buildLogsSectionGroup } from '../shared/feed.section';

@RegisterEntityHandler('analyticsbasereport')
@Injectable()
export class AnalyticsBaseReportsHandler extends EntityHandler<AnalyticsBaseReportResponse> {

    constructor(
        admin: AdminEditorService,
        private issues: HealthIssueService,
        private sanitizer: DomSanitizer
    ) {
        super(admin);
    }

    async listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {

        let owner: string = null;
        let client: string = null;
        const company = await this.admin.getCached(`getCompany/${ownerId}`, api => api.accounts.getCompany(ownerId));
        if (company.type === 'client') {
            client = ownerId;
        } else {
            owner = ownerId;
        }
        return this.admin.getCached(`listAnalyticsBaseReports/null/${ownerId}/null/${offset}/${limit}/${sort}/${filter}`, api => api.reports.listAnalyticsBaseReports(owner, client, null, offset, limit), 3).then(response => ({
            ...response,
            type: 'analyticsbasereport',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.ANALYTICSBASEREPORTS'),
        }));
    }

    getEntity(id: string): Promise<AnalyticsBaseReportResponse> {
        return this.admin.getCached(`getAnalyticsBaseReport/${id}`, api => api.reports.getAnalyticsBaseReport(id), 10);
    }

    async createEntity(_ownerId: string, _entity: any): Promise<AnalyticsBaseReportResponse> {
        throw new Error('Not supported');
    }

    async setEntityState(_entity: any, _state: string): Promise<any> {
        throw new Error('Not supported');
    }

    getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.ANALYTICSBASEREPORT.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', ICONS.analyticsbasereport),
            grid.TextColumn('title', 'TITLE'),
            grid.TextColumn('user.name', 'USER'),
            grid.TextColumn('mode', 'MODE', 80),
            grid.TextColumn('status', 'STATUS', 90),
            grid.NumberColumn('progress', 'PROGRESS', 70),
            grid.TimeAgoColumn('lastCompletedDate', 'LAST_RUN_DATE'),
            grid.TimeAgoColumn('date', 'DATE'),
        ];
        return Promise.resolve(columns);
    }

    async getEditorSections(ownerId: string, entity: AnalyticsBaseReportResponse): Promise<SectionHandlerGroup<AnalyticsBaseReportResponse>[]> {

        let issues: ContextualizedHealthIssue[] = [];
        if (entity?.dashboards) {
            for (const dashboard of entity.dashboards) {
                const dashboardIssues = await this.issues.getIssuesForEntity(dashboard.owner.id, dashboard.id, 5);
                issues.push(...dashboardIssues.filter(x => x.source.id === entity.id));
            }
        }
        issues = uniqBy(issues, 'source.id');

        return [
            {
                name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
                sections: [
                    new AnalyticsBaseReportSectionHandler(this.admin, ownerId),
                    new AnalyticsDashboardListSectionHandler(this.admin, ownerId),
                ],
                warnings: entity && issues.map(issue => {
                    return this.sanitizer.bypassSecurityTrustHtml(`<strong>${issue.title}</strong><br>${issue.description}<br><a href="/#/admin/${entity.owner.type}/${entity.owner.id}/healthissues/grid/healthissue/${issue.id}">More</a>`);
                }) || [],
            },
            this.admin.user.owner.type === 'system' && buildLogsSectionGroup(this.admin, 'analyticsbasereport'),
        ].filter(x => x);
    }

    getCreationSections(_ownerId: string): Promise<{ entityType: string, entity: any, sections: FormSectionHandler<AnalyticsBaseReportResponse, any>[] }> {
        return null;
    }

}




